// When the display merchant is normalized (substituted) from the bank's raw
// descriptor, the raw string must stay reachable -- a desktop hover tooltip
// AND a tap/click disclosure (phone has no hover), never silently dropped.
//
// The component mounts its own TooltipProvider so it works anywhere -- inside
// a page rendered in isolation by a test, or a surface that forgot the root
// provider. Radix allows nested providers, and App.tsx still mounts a root
// one for every other tooltip consumer.
import { useState } from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@moneyskyline/ui';

export function MerchantName({
  display,
  raw,
  substituted,
  className,
}: {
  display: string;
  raw: string;
  substituted: boolean;
  className?: string;
}) {
  const [open, setOpen] = useState(false);

  if (!substituted) {
    return (
      <span className={className} data-testid="merchant-name">
        {display}
      </span>
    );
  }

  return (
    <TooltipProvider delayDuration={200}>
      <span className={className} data-testid="merchant-name" data-substituted="true">
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              type="button"
              className="ms-tap-44 underline decoration-dotted underline-offset-2"
              aria-expanded={open}
              aria-label={`${display}, originally "${raw}"`}
              onClick={() => setOpen((v) => !v)}
            >
              {display}
            </button>
          </TooltipTrigger>
          <TooltipContent>{raw}</TooltipContent>
        </Tooltip>
        {open && (
          <span className="ml-1.5 text-xs text-muted-foreground" data-testid="merchant-raw-disclosure">
            originally &ldquo;{raw}&rdquo;
          </span>
        )}
      </span>
    </TooltipProvider>
  );
}

export default MerchantName;
